/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Brainstorm new tasks` - BRAINSTORM_NEW_TASKS
 * * `Plan this project` - PLAN_PROJECT
 * * `Standup report` - STANDUP_REPORT
 * * `Write a changelog` - WRITE_CHANGELOG
 * * `Break into subtasks` - BREAK_INTO_SUBTASKS
 * * `Custom` - CUSTOM
 */
export enum SkillKind {
  BRAINSTORM_NEW_TASKS = 'Brainstorm new tasks',
  PLAN_PROJECT = 'Plan this project',
  STANDUP_REPORT = 'Standup report',
  WRITE_CHANGELOG = 'Write a changelog',
  BREAK_INTO_SUBTASKS = 'Break into subtasks',
  CUSTOM = 'Custom',
}
